import EpfoList from "./Epfo";

export default EpfoList;
